import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { TranslatedToastrService } from '../services/translated-toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { FormatDateService } from '../services/format-date.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        private injector: Injector,
        private formatDateService: FormatDateService
    ) {}

    handleError(error: any) {
        if (error instanceof HttpErrorResponse) {
            console.error('Error from global error handler', error);
        } else {
            let toastr = this.injector.get(TranslatedToastrService);

            let translateService = this.injector.get(TranslateService);
            let errorTitle = translateService.instant('common.error');

            let apiProblem = error as any;
            let bResponse = error as any;
            if (apiProblem && typeof apiProblem === 'object' && 'title' in apiProblem) {
                console.log(apiProblem);
                toastr.error(apiProblem.detail!, apiProblem.title, {
                    onActivateTick: true,
                });
            } else if (bResponse && typeof bResponse === 'object' && 'isSuccess' in bResponse) {
                toastr.error(
                    bResponse.message!,
                    errorTitle,
                    {
                        onActivateTick: true,
                    },
                    bResponse.additionalInformation!
                );
            } else {
                if (error.message) {
                    if (error.status != 504 && error.status != 0 && error.status == undefined && error.name && error.name != 'EmptyError' && error.message != 'no elements in sequence' && error.message != "Cannot read properties of null (reading 'parentNode')") {
                        const errorMessage = `${error.message} - ${this.formatDateService.formatDateTime(new Date())}`;
                        console.log(error);
                        this.customAlert('GlobalErrorHandler - withmessage - ' + errorMessage);
                    }
                } else {
                    const errorMessage = `${JSON.stringify(error)} - ${this.formatDateService.formatDateTime(new Date())}`;
                    console.log(error);
                    this.customAlert('GlobalErrorHandler - withoutmessage ' + errorMessage);
                }
                if (error.status == 504 || error.status == 0) {
                    let checkInternetConnectionMessage = translateService.instant('common.check_internet_connection');
                    console.log(error);
                    toastr.error(checkInternetConnectionMessage, errorTitle, {
                        onActivateTick: true,
                    });
                    //EmptyError with no elements in sequence arrives when the firstValueFrom got an error because there is no response, probably because of the user is not authorized for that request
                } else if (error.status == 401 || (error.name && error.name == 'EmptyError' && error.message == 'no elements in sequence')) {
                    let authErrorMessage = translateService.instant('common.auth_error');
                    console.log(error);
                    toastr.error(authErrorMessage, errorTitle, {
                        onActivateTick: true,
                    });
                } else {
                    if (error.message == "Cannot read properties of null (reading 'parentNode')") {
                        return;
                    }
                    console.log(error);
                    toastr.error(error.message, errorTitle, {
                        onActivateTick: true,
                    });
                }
            }
        }
    }

    private customAlert(message: string): void {
        $('#custom-alert-overlay').remove();

        let tokenSection = '';

        // if (window.token != null && window.tokenDate != null) {
        //     tokenSection = `<div id="custom-alert-token">${window.token}: ${window.tokenDate}</div>`;
        // }

        let alertHtml = $(`
            <div id="custom-alert-overlay">
                <div id="custom-alert-box">
                    <div id="custom-alert-message">${message}</div>
                    ${tokenSection}
                    <div id="custom-alert-buttons">
                        <button id="copy-alert">Copy</button>
                        <button id="close-alert">Close</button>
                    </div>
                </div>
            </div>
        `);

        // Overlay (background)
        alertHtml.css({
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.4)',
            'z-index': 9999,
            display: 'flex',
            'align-items': 'flex-start',
            'justify-content': 'center',
            'padding-top': '40px',
        });

        // Alert box
        alertHtml.find('#custom-alert-box').css({
            background: 'red',
            color: 'white',
            padding: '20px',
            'border-radius': '10px',
            'min-width': '300px',
            'max-width': '80%',
            'box-shadow': '0 0 15px rgba(0,0,0,0.5)',
            'text-align': 'center',
        });

        alertHtml.find('#custom-alert-message').css({
            color: 'white',
        });

        // Buttons container
        alertHtml.find('#custom-alert-buttons').css({
            'margin-top': '15px',
            display: 'flex',
            gap: '1rem',
            'justify-content': 'end',
        });

        alertHtml.find('button').css({
            padding: '8px 15px',
            border: 'none',
            'border-radius': '5px',
            cursor: 'pointer',
        });

        alertHtml.find('#copy-alert').css({
            padding: '8px 15px',
            border: 'none',
            'border-radius': '5px',
            cursor: 'pointer',
            background: '#333',
            color: 'white',
        });

        alertHtml.find('#close-alert').css({
            padding: '8px 15px',
            border: 'none',
            'border-radius': '5px',
            cursor: 'pointer',
            background: '#888',
            color: 'white',
        });

        $('body').append(alertHtml);

        $('#close-alert').on('click', function () {
            $('#custom-alert-overlay').remove();
        });

        $('#copy-alert').on('click', function () {
            navigator.clipboard
                .writeText(message)
                .then(() => {
                    $(this).text('Copied!');
                })
                .catch(() => {
                    alert('Copy failed');
                });
        });
    }
}
